import { terminalOperation } from "@/models/ui/operation";
import { ROUTE_NAMES } from "@/router/routes";

/**
 * A place for functions which operate on operations to apply.
 */
export function useTerminalOperations() {
  const terminalOperations: terminalOperation[] = [
    {
      value: 0,
      title: "Tanker Receipt",
      image: new URL(`@/assets/images/MarineTanker.png`, import.meta.url).href,
      name: `${ROUTE_NAMES.RECEIPT_PLAN_LIST}`,
      enabled: true,
    },
    {
      value: 1,
      title: "Tank to Tank Transfer",
      image: new URL(`@/assets/images/TankToTankDischarge.png`, import.meta.url)
        .href,
      name: `${ROUTE_NAMES.TANK_TO_TANK_PLAN_LIST}`,
      enabled: false,
    },
    {
      value: 2,
      title: "Levels of Concern",
      image: new URL(`@/assets/images/Warning.png`, import.meta.url).href,
      name: `${ROUTE_NAMES.LEVELS_OF_CONCERN}`,
      enabled: true,
    },
    {
      value: 3,
      title: "Terminal Data",
      image: new URL(`@/assets/images/Data.png`, import.meta.url).href,
      name: `${ROUTE_NAMES.TERMINAL_DATA_TERMINAL_INFORMATION}`,
      enabled: true,
    },
  ];

  return {
    terminalOperations,
  };
}
